import React, { useEffect, useState } from "react";
import { API } from "../../pages/backend";
import { useFlutterwave } from "flutterwave-react-v3";
import {
    Box,
    Button,
    Card,
    Container,
    FormControl,
    Modal,
    FormControlLabel,
    FormLabel,
    Grid,
    Radio,
    RadioGroup,
    Typography,
    InputLabel,
    Select,
    MenuItem,
    Popover,
    Avatar,
    TextField,
} from "@mui/material";
// import Footer from "../../Component/Footer";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import ProceedModal from "../../Component/ProceedModal";
import { styled } from "@mui/system";
import ProceedModalPrint from "../../Component/ProceedModalPrint";
import Swal from "sweetalert2";
import Layout from "../../reusables/layout/layout";
import InputField from "../forms/input/TextInput/InputField";
import { useDispatch, useSelector } from "react-redux";
// import BulkPublic from "../../Component/BulkPublic";
import IndividualPublic from "../../Component/IndividualPublic";
import { showModal, openModal } from "../../store/reducers/modal";
import IndividualModel from "../IndividualModel";
import BulkPublic from "../BulkPublic";
import VerifyPayerId from "../VerifyPayerId";
import data from "../dropDown";
import FormButton from "../ui/button/FormButton";
import Tab from "../../Component/tab";
import Spinner from "../ui/Spinner";
// import { examDetailsChanger } from '../../partials';
import { examPrices } from "../../partials/examboardprices/examprices";

import { setTransactionDetails } from "../../store/reducers/transactionDetails";
import { toast } from "react-toastify";
import BillCard from "../paymentcard/billcard";
import TransactionCard from "../transactioncard/transactioncard";
// import { validateForm } from "../../Component/validationForm";
// import SubTab from "./subtabs";
import PaymentDispute from "../disputecard/dispute";

const LateReqPublic = ({ examName = "Public Service", examType, lateRegistrationType = 'Public Service Late Registration' }) => {
    const [testType, setTestType] = useState("External Secretariat");
    const [testSubType, setTestSubType] = useState("CS II");

    const optionsObj = {
        "External Secretariat": ["CS II", "CS III", "CS IV"],
        "Trade Test": ["Stage I", "Stage II", "Stage III"],
        "Executive Admin": ["Confirm/Combined II", "Confirm/Combined III"],
    };

    const [tab, setTab] = useState(0);

    const tabs = ["User Details", "Payment Details", "Transaction Details", "Log Payment Dispute"];

    const [publicTab, setPublicTab] = useState(0);

    const tabsPublic = ["Individual", "Bulk"];


    let price = "0";
    // let price = (testType === "External Secretariat") ? examPrices.publicServiceExamSecretarial : examPrices.publicServiceExamTradeTest

    switch (testType) {
        case "External Secretariat":
            price = examPrices.publicServiceLateRegExamSecretarial;
            break;

        case "Trade Test":
            price = examPrices.publicServiceLateRegExamTradeTest;
            break;

        case "Executive Admin":
            price = examPrices.publicServiceLateRegExamCombined;
            break;

        default:
            price = "0";
            break;
    }

    const priceInt = price.replace(/\D/g, "");
    const totalFee = priceInt;
    const charge = 0.029 * totalFee;
    const totalAmount = parseInt(charge) + parseInt(totalFee);

    const dispatch = useDispatch();

    const { LgaForPublic } = data;
    const [lgaForPublic, setLgaForPublic] = useState("");
    const [middleName, setMiddleName] = useState("");
    const [mda, setMda] = useState("");
    const [designation, setDesignation] = useState("");

    const [closingDate, setClosingDate] = useState("");
    const [service, setService] = useState(""); // service type
    const [nos, setNos] = useState(""); // name of candidate
    const [school, setSchool] = useState(""); // current school
    const [choiceSchool, setChoiceSchool] = useState(""); // choice school
    const [schoolId, setSchoolId] = useState(""); // school id
    const [lgvt, setLgvt] = useState(""); // lgvt
    const [agent, setAgent] = useState(""); // agent
    const [pid, setPid] = useState(""); // pid
    const [pinNum, setPinNum] = useState([]);
    const [addrs, setAddrs] = useState("");
    const [str, setStr] = useState("");
    const [twncty, setTwncty] = useState("");
    const [mystate, setMystate] = useState("");
    const [phone, setPhone] = useState("");
    const [email, setEmail] = useState("");
    const [cost, setCost] = useState(0);
    const [candidates, setCandidates] = useState("");
    const [schoolType, setSchoolType] = useState("");
    const [allFetchedSchools, setAllFetchedSchools] = useState([]);
    // error for validation form
    const [errors, setErrors] = useState({});

    // const [feePerCandidate, setFeeForCandidate] = useState(5000)
    // const [noOfCandidates, setNoOfCandidates] = useState()

    // const price = (examName === 'B.E.C.E') ? examPrices.beceExamFeePerCandidate : examPrices.casExamFeePerCandidate;
    // const [priceInt, setPriceInt] = useState(price.replace(/\D/g, ''))
    // const totalFee = priceInt * noOfCandidates;

    const [open, setOpen] = useState(false);
    const [modelToken, setModelToken] = useState("");
    // const [user, setUser] = useState();

    const user = useSelector((state) => state.user.data.details);
    const token = useSelector((state) => state.user.data.token);
    const details = useSelector((state) => state.transactionDetails);

    console.log(token);

    console.log(user);

    const [invoiceLoading, setInvoiceLoading] = useState(false);

    const [anchorEl, setAnchorEl] = useState(null);

    const openAnchor = Boolean(anchorEl);

    const closeAnchor = () => {
        setAnchorEl(null);
    };

    const handleLogOut = () => {
        setAnchorEl(null);;
        navigate("/public/payment/login");
    };
    const handleClose = () => setOpen(false);

    const [openBulk, setOpenBulk] = useState(false);
    const [openIndividual, setOpenIndividual] = useState(false);

    const handleCloseIndividual = () => {
        setOpenIndividual(false);
    };
    const handleCloseBulk = () => {
        setOpenBulk(false);
    };

    const handleExamType = (e) => {
        console.log(e.target.value);
        if (e.target.value === "BULK") {
            setOpenBulk(true);
        }
        if (e.target.value === "INDIVIDUAL") {
            setOpenIndividual(true);
        }
    };


    const handleSchoolType = async (e) => {
        setSchoolType(e.target.value);
        console.log(e.target.value);

        let typeParam;

        if (e.target.value === "Public") typeParam = "1";
        if (e.target.value === "Private") typeParam = "0";

        try {
            const response = await axios.get(`${API}typejss/${typeParam}/`);
            console.log(response);

            setAllFetchedSchools(response.data);
        } catch (error) {
            //error catching

            console.log(error);
        }
    };

    const getSchoolInfo = async (id) => {
        const filteredSchool = allFetchedSchools.filter(
            (school) => school.SchoolId === id
        );

        console.log(filteredSchool);
        if (filteredSchool) {
            setSchool(filteredSchool[0].SchoolName);
            setLgvt(filteredSchool[0].LgaId);
            setClosingDate(filteredSchool[0].ClosingDate);
            console.log(filteredSchool[0].ClosingDate);
        }
    };

    const handleSchoolId = (e) => {
        // const red = /^[0-9\b]+$/;
        // let valleng = e.target.value.length;
        // console.log(`length: ${valleng}`)
        // if (e.target.value === '' || red.test(e.target.value)) {
        setSchoolId(e.target.value);
        //     if(valleng === 5)
        getSchoolInfo(e.target.value);
        // }

        // if (valleng === 5) {
        //     axios.get(`http://localhost:5000/getvals`)
        //         .then(res => {
        //             setSchool(res.data.nameofsch);
        //             setLgvt(res.data.locgovt);
        //             setChoiceSchool(res.data.schoolchoice) // i belive the quota for the school will likewise be determined by their id
        //         })
        // }
    };

    const handleOnchange = (e) => {
        var changes = e.target.name;
        // console.log(`My Value is ${changes}`);
        if (changes === "nocand") {
            setNos(e.target.value);
        }

        if (changes === "pid") {
            const red = /^[0-9\b]+$/;
            if (e.target.value === "" || red.test(e.target.value)) {
                setPid(e.target.value);
            }
        }
        if (changes === "service") {
            setService(e.target.value);
        }
        if (changes === "current") {
            setSchool(e.target.value);
        }
        if (changes === "choice") {
            setChoiceSchool(e.target.value);
        }
        if (changes === "lgvt") {
            setLgvt(e.target.value);
        }
        if (changes === "agent") {
            setAgent(e.target.value);
        }
        if (changes === "candidates") {
            const red = /^[0-9\b]+$/;
            if (e.target.value === "" || red.test(e.target.value)) {
                setCandidates(e.target.value);
            }
        }

        if (changes === "email") {
            setEmail(e.target.value);
        }

        if (changes === "contphone") {
            const red = /^[0-9\b]+$/;
            if (e.target.value === "" || red.test(e.target.value)) {
                setPhone(e.target.value);
            }
            console.log(`Telephone ${e.target.value}`);
        }

        if (changes === "address") {
            setAddrs(e.target.value);
        }

        if (changes === "street") {
            setStr(e.target.value);
        }

        if (changes === "towncity") {
            setTwncty(e.target.value);
        }

        if (changes === "ngnstate") {
            setMystate(e.target.value);
        }
    };

    const config = {
        public_key: process.env.REACT_APP_PUBLIC_KEY,
        tx_ref: Date.now(),
        amount: 9,
        currency: "NGN",
        payment_options: "card,mobilemoney,ussd",
        customer: {
            email: email,
            phonenumber: phone,
        },
        customizations: {
            title: "Lagos Pay",
            description: "PAYMENT FOR EXAMINATION (CBS)",
            logo: "https://pbs.twimg.com/media/EtEwgbvXMAQfCXT.jpg",
        },
    };

    const handleFlutterPayment = useFlutterwave(config);

    const handlePayment = (id) => {
        handleFlutterPayment({
            callback: (response) => {
                console.log(`Flutter Response: ${response}`);
                if (response.status === "successful") {
                    console.log("PAYMENT IS SUCCESSFUL");
                    setOpen(true);
                    setPinNum(id);
                }
            },
            onClose: () => { },
        });
    };

    const handleClick = async (e) => {
        e.preventDefault();

        const obj = {
            SchoolId: schoolId,
            SchoolType: schoolType,
            PayerName: agent,
            // Payeremail: email,
            Payerphone: phone,
            Address: addrs,
            State: mystate,
            City: twncty,
            NumberOfCandidates: candidates,
            currentSchoolName: "PAID",
            ChoiceSchoolName: choiceSchool,
            LgaId: lgvt,
            ClosingDate: closingDate,
        };
        console.log("school:", obj);

        try {
            const response = await axios.post(`${API}mcollege/generate_pin/`, obj);
            console.log(response, "i am here");

            if (response.status === 200) {
                const costy = response ? response.data[0].fields.ExamCost : "";
                console.log(costy);
                setCost(costy);
                handlePayment(response.data);
            }
        } catch (err) {
            if (err.response.data.detail) {
                Swal.fire({
                    title: "Error",
                    text: "your request is late, u will be paying a 30 percent increase",
                    icon: "error",
                    confirmButtonText: "Ok",
                });
            }
        }
    };

    const types = [
        {
            name: "Private",
            label: "Private",
        },
        {
            name: "Public",
            label: "Public",
        },
    ];

    const style = {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        maxWidth: { xs: "96%", md: "60%" },
        bgcolor: "background.paper",
        boxShadow: 24,
        //  py: 1,
        // px: 1,
        borderRadius: 5,
        overflowY: "auto",
        height: "50vh",
    };

    const navigate = useNavigate();

    // const handleInvoiceClick = () => {
    //     return (user?.categoryId === 2 || user?.categoryId === 3)
    //         ? navigate("/teller-preview")
    //         : " "
    // }

    const handleTestTypeClick = (val) => {
        setTestType(val.target.value);
    };

    const handleTestSubTypeClick = (val) => {
        setTestSubType(val.target.value);
    };

    const handleInvoiceClick = async (e) => {
        setInvoiceLoading(true);
        try {
            e.preventDefault();
            const isLgaEmpty = lgaForPublic.trim() === "";

            if (isLgaEmpty) {
                throw new Error("Local Government Field is required");
            }
            await generateBillNo();
            // console.log(transactionDetails)
            // console.log(examName)
        } catch (error) {
            console.log(error);
            toast.error(error.message);
        } finally {
            setInvoiceLoading(false);
        }
    };

    // const handleRadioClick = (e) => {
    //   if (e.target.value === "Individual") {
    //     dispatch(showModal({ content: <IndividualModel /> }));
    //   } else if (e.target.value === "Bulk") {
    //     dispatch(showModal({ content: <BulkModel /> }));
    //   }
    // };

    const [radioValue, setRadioValue] = useState("Individual");

    const handleRadioClick = (e) => {
        if (e.target.value === "BulkPublic") {
            dispatch(showModal({ content: <BulkPublic /> }));
        } else if (e) {
            setRadioValue(radioValue === e ? " " : e);
        }
        // else {
        //   setRadioValue("Individual");
        // }
    };

    const handlePayerIdClick = () => {
        dispatch(showModal({ content: <VerifyPayerId /> }));
    };

    const goBack = () => {
        window.history.back();
    };

    useEffect(() => {
        if (optionsObj[testType]) {
            setTestSubType(optionsObj[testType][0]);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [testType]);

    const saveGeneratedBill = async (body) => {
        try {
            const res = await axios.post(`${API}auth/bills/create`, body, {
                headers: { Authorization: `Bearer ${token}` },
            });
            console.log(res);
        } catch (error) { }
    };

    const generateBillNo = async () => {
        const fullDesc =
            examName === "CAS/Placement"
                ? "Placement (Primary) All Primary Registration Fee[NGN]"
                : "Basic Education Certification[NGN]";

        const body = {
            payerId: "N-8592972",
            customerName: `${user.firstName} ${user.lastName}`,
            customerAddress: user.address,
            totalAmountInvoiced: totalFee,
            invoiceItems: [
                {
                    productId: "68323",
                },
            ],
        };

        try {
            const res = await axios.post(`${API}cbs/create_invoice`, body, {
                headers: { Authorization: `Bearer ${token}` },
            });
            // console.log(res)
            if (res?.status === 200) {
                console.log(res?.status);
                console.log(res?.data);
                console.log(res?.data?.data?.responseData);

                const billdata = {
                    billNumber: res?.data?.data?.responseData,
                    payerId: res?.data?.data?.payerId,
                    amount: totalFee,
                    fullName: `${user.firstName} ${user.lastName}`,
                    totalPaidForOrAllocated: 1,
                    assessmentCode: "02",
                    paymentOwners: [
                        {
                            examsIdOrSchoolId: user?.schoolId,
                        },
                    ],
                };
                const bill = saveGeneratedBill(billdata);
                console.log(bill);
                // transactionDetails.billNumber = res?.data?.data?.responseData;
                // console.log(transactionDetails);
                const userTransactionDetails = {
                    payerName: `${user.firstName} ${user.lastName}`,
                    productQuantity: 1,
                    price: totalFee,
                    schoolName: "",
                    unitPrice: priceInt,
                    examType,
                    paymentExamType: examName,
                    fullDesc: "Public Service Examination [NGN]",
                    billNumber: res?.data?.data?.responseData,
                    payerId: user?.payerId,
                    address: user?.address,
                    schoolName: user?.schoolName,
                    priceWithCharge: totalAmount,
                };
                dispatch(setTransactionDetails(userTransactionDetails));
                console.log(userTransactionDetails);
                console.log(details);

                // dispatch(setTransactionDetails(details.billNumber = res?.data?.data?.responseData ));
                // console.log(details)
                navigate("/invoice");
            }
            console.log(res);
        } catch (error) {
            toast.error("Session expired. Please logout and try again.");
            console.log(error);
        }
    };

    // validation Form for LGA
    // const handleChange = (e) => {
    //   const { value } = e.target;
    //   // Update the field value
    //   setLgaForPublic(value);
    //   // Validate the field
    //   const newErrors = validateForm({ lgaForPublic: value });
    //   setErrors(newErrors);
    // };
    const LateReqFormPublic = () => {
        return (
            <Container sx={{ mt: 5 }}>
                <Box marginTop={"20px"} padding={"10px 30px"}>
                    <div>
                        <Grid container spacing={2}>
                            <Grid item xs={6}>
                                <InputField
                                    name="firstName"
                                    label="First Name"
                                    type="firstName"
                                    placeholder="First Name"
                                    value={user?.firstName}
                                    // onChange={(e) => {
                                    //     setUsername(e.target.value);
                                    // }}
                                    readOnly
                                    style={{ height: "100%", textTransform: 'capitalize' }}
                                />
                            </Grid>
                            <Grid item xs={6}>
                                <InputField
                                    name="middleName"
                                    label="Middle Name"
                                    type="text"
                                    placeholder="Middle Name"
                                    value={user?.middleName}
                                    // value={middleName}
                                    onChange={(e) => setMiddleName(e.target.value)}
                                    style={{ height: "100%", textTransform: 'capitalize' }}
                                />
                            </Grid>
                        </Grid>
                    </div>
                    <div>
                        <Grid container spacing={2}>
                            <Grid item xs={6}>
                                <InputField
                                    name="lastName"
                                    label="Last Name"
                                    type="lastName"
                                    placeholder="Last Name"
                                    value={user?.lastName}
                                    // onChange={(e) => {
                                    //     setUsername(e.target.value);
                                    // }}
                                    readOnly
                                    style={{ height: "100%", textTransform: 'capitalize' }}
                                />
                            </Grid>
                            <Grid item xs={6} style={{ position: "relative" }}>
                                <Typography
                                    href=""
                                    color="secondary"
                                    style={{
                                        color: "#e53e3e",
                                        fontSize: "13px",
                                        position: "absolute",
                                        top: "1.8rem",
                                        left: "7rem",
                                        cursor: "pointer",
                                    }}
                                    variant="p"
                                    onClick={handlePayerIdClick}
                                >
                                    Verify Payer ID
                                </Typography>
                                <InputField
                                    name="Payer ID"
                                    label="Payer ID"
                                    placeholder="Payer ID"
                                    value={user?.payerId}
                                    type="payerId"
                                    style={{ height: "100%" }}
                                />
                            </Grid>
                        </Grid>
                    </div>

                    <Grid container spacing={2}>
                        <Grid item xs={6}>
                            <InputField
                                name="Phone No"
                                label="Phone No"
                                type="phone"
                                placeholder="Enter phone number"
                                value={user?.phoneNumber}
                                style={{ height: "100%" }}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <InputField
                                name="Email"
                                label="Email"
                                placeholder="Email"
                                value={user?.email}
                                type="email"
                                style={{ height: "100%" }}
                            />
                        </Grid>
                    </Grid>

                    <div>
                        <FormControl  component="fieldset">

                            {/* <FormLabel component="legend">Test Type</FormLabel> */}
                            <RadioGroup
                                aria-label="individual"
                                name="radio-button"
                                value={radioValue}
                                // value={testType}
                                style={{ marginTop: "2rem", }}
                            >
                                <FormControlLabel
                                    value="Individual"
                                    control={<Radio />}
                                    label="Single Payment"
                                    
                                />
                                <FormControlLabel
                                    value="BulkPublic"
                                    control={<Radio />}
                                    label="Bulk Payment"
                                    style={{ marginTop: "1rem",   }}
                                    onChange={handleRadioClick}
                                />
                            </RadioGroup>
                        </FormControl>
                    </div>

                    <Grid
                        container
                        alignItems={"center"}
                        alignContent={"center"}
                        my={2}
                        spacing={2}
                    >
                        <Grid item xs={6}>
                            <Typography
                                variant="body1"
                                sx={{
                                    color: "#9b9494",
                                    fontSize: "1rem",
                                    fontWeight: "bolder",
                                }}
                                mb={1}
                            >
                                Test Type
                            </Typography>

                            {/* <InputLabel id="test-type-select-label">Test Type</InputLabel> */}
                            <Select
                                id="test-type-select"
                                value={testType}
                                onChange={handleTestTypeClick}
                                label={"Test Type"}
                                labelId="test-type-select"
                                style={{ width: "100%" }}
                            >
                                <MenuItem value={"External Secretariat"}>
                                    External Secretariat
                                </MenuItem>
                                <MenuItem value={"Trade Test"}>Trade Test</MenuItem>
                                <MenuItem value={"Executive Admin"}>Executive Admin</MenuItem>
                            </Select>
                        </Grid>

                        <Grid item xs={6}>
                            <Typography
                                variant="body1"
                                sx={{
                                    color: "#9b9494",
                                    fontSize: "1rem",
                                    fontWeight: "bolder",
                                }}
                                mb={1}
                            >
                                Test Sub-type
                            </Typography>{" "}
                            <InputLabel id="test-sub-type-select-label">
                                {/* Test Sub-Type */}
                            </InputLabel>
                            <Select
                                id="test-sub-type-select"
                                value={testSubType}
                                onChange={handleTestSubTypeClick}
                                label={"Test Sub-Type"}
                                labelId="test-sub-type-select-label"
                                style={{ width: "100%" }}
                            >
                                {optionsObj[testType]
                                    ? optionsObj[testType].map((el, idx) => (
                                        <MenuItem key={`${el} - ${idx}`} value={el}>
                                            {el}
                                        </MenuItem>
                                    ))
                                    : ""}
                            </Select>
                        </Grid>
                    </Grid>

                    {/* <div>
            <Grid container spacing={2}>
              <Grid item xs={6}>
                <InputField
                  label="Oracle ID"
                  name="Oracle "
                  value={user?.oracle}
                  placeholder="Oracle ID"
                  type="oracle"
                  style={{ height: "100%" }}
                />
              </Grid>
              <Grid item xs={6}>
                <InputField
                  name="lASRA"
                  label="LASRA"
                  value={user?.lasra}
                  placeholder="LASRA"
                  type="lasra"
                  style={{ height: "100%" }}
                />
              </Grid>
            </Grid>
          </div> */}

                    <Grid container spacing={2}>
                        <Grid item xs={12} md={6}>
                            <InputField
                                name="MDA"
                                label="MDA"
                                // value={user?.mda}
                                placeholder="Ministry, department or agency"
                                type="text"
                                value={mda}
                                onChange={(e) => setMda(e.target.value.trim())}
                                style={{ height: "100%" }}
                            />
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <InputField
                                name="currentOffice"
                                label="Designation"
                                type="text"
                                placeholder="Enter Current Office or Position"
                                value={designation}
                                onChange={(e) => setDesignation(e.target.value.trim())}
                                style={{ height: "100%" }}
                            />
                        </Grid>
                    </Grid>

                    <Grid container spacing={2}>
                        <Grid item xs={6}>
                            <InputField
                                name="test-price"
                                label="Price"
                                type="text"
                                value={price}
                                style={{ height: "100%" }}
                            />
                        </Grid>
                        <Grid item xs={6}>
                            <Typography
                                variant="body1"
                                sx={{
                                    color: "#9b9494",
                                    fontSize: "14px",
                                    fontWeight: "bold",
                                    paddingTop: "1.2rem",
                                }}
                            >
                                Local Government
                            </Typography>
                            <TextField
                                label="Select Local Government Area"
                                select
                                value={lgaForPublic}
                                onChange={(e) => setLgaForPublic(e.target.value)}
                                // onChange={handleChange}
                                // error={!!errors.lgaForPublic} // Highlight the field if there's an error
                                // helperText={errors.lgaForPublic}
                                style={{
                                    height: "100%",
                                    width: "100%",
                                }}
                            >
                                {LgaForPublic.map((lgaItem) => (
                                    <MenuItem key={lgaItem.ledId} value={lgaItem.ledId}>
                                        {lgaItem.name}
                                    </MenuItem>
                                ))}
                            </TextField>
                        </Grid>
                    </Grid>
                </Box>

                {/* <tabs style={{width:'30%'}} >
          {tabsPublic.map((x, i) => <SubTab key={i} text={x} active={i === publicTab} onClick={() => setPublicTab(i)} />)}
        </tabs>

        {(publicTab === 0) && Individual()}
        {(publicTab === 1) && BulkModel()} */}
                {/* {(tab === 2) && <PlatformTransactionDetails />} */}

                <div
                    style={{
                        marginTop: "3rem",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <FormButton
                        width="medium"
                        label={invoiceLoading ? <Spinner width="1%" /> : "Generate Invoice"}
                        onClick={handleInvoiceClick}
                    />

                    <div>
                        <FormButton width="medium" label={" Go Back"} onClick={goBack} />
                    </div>
                </div>
            </Container>
        );
    };

    const PaymentForm = () => {
        return <BillCard />;
    };

    const PlatformTransactionDetails = () => {
        return <TransactionCard />;
    };

    useEffect(() => {
        console.log(user);
    }, [cost]);

    return (
        <div>
            <Layout>
                <Card className="model-card" elevation={5}>
                    <Box
                        component="form"
                        noValidate
                        autoComplete="off"
                        className="bece-form-left"
                    >
                        <div style={{ padding: "0px 5px" }}>
                            <marquee bgcolor="white" direction="left" loop="">
                                <Typography>
                                    <span
                                        style={{
                                            color: "red",
                                            fontSize: "14px",
                                            fontWeight: "600",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                        }}
                                    >
                                        *This is a Late Payment Form. You are paying outside the initial exam window.
                                    </span>
                                </Typography>
                            </marquee>
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    paddingTop: "5px",
                                    alignItems: "center",
                                }}
                            >
                                <div
                                    style={{
                                        paddingTop: "10px",
                                        alignItems: "center",
                                    }}
                                >
                                    <Typography
                                        variant="subtitle1"
                                        style={{
                                            // marginLeft: "10px",
                                            // paddingTop: "8px",
                                            fontSize: "1.2rem",
                                            fontWeight: "bold",
                                        }}
                                    >
                                        Welcome back
                                    </Typography>
                                    <Typography
                                        style={{
                                            fontSize: "20px",
                                            fontWeight: "bold",
                                            textTransform: 'capitalize',
                                        }}
                                    >
                                        {user?.firstName + " " + user?.lastName}
                                    </Typography>
                                </div>
                                <div>
                                    <Avatar
                                        className=" lg:!flex xs:!hidden items-center"
                                        size="large"
                                        onClick={(e) => setAnchorEl(e.currentTarget)}
                                        aria-label="account-circle"
                                        style={{
                                            backgroundColor: "#34A56F",
                                            // lineHeight: '50px',
                                            fontFamily: "Palanquin",
                                            fontStyle: "normal",
                                            fontWeight: 700,
                                            fontSize: "20px",
                                            textAlign: "center",
                                            cursor: "pointer",
                                            width: "35px",
                                            height: "35px",
                                        }}
                                    >
                                        {user?.firstName?.charAt(0)?.toUpperCase() +
                                            user?.lastName?.charAt(0)?.toUpperCase()}
                                    </Avatar>
                                    <Popover
                                        open={openAnchor}
                                        anchorEl={anchorEl}
                                        onClose={closeAnchor}
                                        anchorOrigin={{
                                            vertical: "bottom",
                                            horizontal: "right",
                                        }}
                                        transformOrigin={{
                                            vertical: "top",
                                            horizontal: "right",
                                        }}
                                    >
                                        <MenuItem onClick={handleLogOut}>Logout</MenuItem>
                                    </Popover>
                                </div>
                            </div>
                        </div>
                        <div style={{

                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center'
                        }}>
                            <Typography
                                variant="h5"
                                align="center"
                                sx={{ paddingTop: "3rem", fontWeight: "bold" }}
                            >
                                {examType}
                            </Typography>
                            <Typography

                                align="center"
                                style={{
                                    color: 'white',
                                    fontSize: '22px',
                                    padding: "0px 5px",
                                    fontWeight: "bold",
                                    marginTop: "5px",
                                    background: '#FD0014',
                                    width: '180px',
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    borderRadius: '3px'
                                }}
                            >
                                {"Late Payment"}
                            </Typography>
                        </div>


                        <tabs>
                            {tabs.map((x, i) => (
                                <Tab
                                    key={i}
                                    text={x}
                                    active={i === tab}
                                    onClick={() => setTab(i)}
                                />
                            ))}
                        </tabs>

                        {tab === 0 && LateReqFormPublic()}
                        {tab === 1 && <PaymentForm />}
                        {tab === 2 && <PlatformTransactionDetails />}
                        {tab === 3 && <PaymentDispute type={examType} />}

                    </Box>
                    <Box compnent="div" className="model-form-right">
                        <Typography
                            variant="h4"
                            align="center"
                            sx={{ color: "#ffffff", paddingTop: "3rem", fontWeight: "bold" }}
                        >
                            Lagos State Exam Board
                        </Typography>
                        <img src={"/assets/images/laags.png"} alt="logo" />
                        <Typography
                            variant="h4"
                            align="center"
                            sx={{ color: "white", fontWeight: "bold", mb: 3 }}
                        >
                            {lateRegistrationType}
                        </Typography>
                        <Typography
                            variant="body2"
                            align="center"
                            sx={{ color: "white", fontSize: "20px" }}
                        >
                            Fill the form to request for the Official Central Billing System
                            Invoice ID
                        </Typography>
                    </Box>
                </Card>
                {/* <Modal
          open={openIndividual}
          onClose={handleCloseIndividual}
          keepMounted
          aria-labelledby="keep-mounted-modal-title"
          aria-describedby="keep-mounted-modal-description"
        >
          <Box sx={style}>
            <IndividualPublic
              handleClose={handleCloseIndividual}
              data={user?.payerId}
            />
          </Box>
        </Modal>
        <Modal
          open={openBulk}
          onClose={handleCloseBulk}
          keepMounted
          aria-labelledby="keep-mounted-modal-title"
          aria-describedby="keep-mounted-modal-description"
        >
          <Box sx={style} className="modal-scrollbar">
            <BulkPublic handleClose={handleCloseBulk} data={user?.payerId} />
          </Box>
        </Modal> */}
                {/* <ProceedModalPrint pin={pinNum} open={open} handleClose={handleClose} /> */}
            </Layout>
            {/* <Footer /> */}
        </div>
    );
};

export default LateReqPublic;
